export default "__VITE_ASSET__DEC$koEB__"